<template>
  <b-container fluid class="my-4">
    <b-row>
      <b-col cols="12" md="8" lg="6" class="mx-auto">
        <b-card title="Crear Farmaco">
          <validation-observer v-slot="{ invalid }" ref="observer">
            <b-form @submit.prevent="submitForm">
              <b-form-group>
                <label>Nombres: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nombre"
                  rules="required"
                >
                  <b-form-input
                    id="nombre"
                    :state="errors.length > 0 ? false : null"
                    v-model="medicamento.nombre"
                    type="text"
                    onkeypress="return (event.charCode == 209 || event.charCode == 241 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label-for="codigo">
                <label>Código: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="codigo"
                  rules="required"
                >
                  <b-form-input
                    id="codigo"
                    :state="errors.length > 0 ? false : null"
                    v-model="medicamento.codigo"
                    type="text"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label-for="precioneto">
                <label>Precio Neto: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="precioneto"
                  rules="required"
                >
                  <b-form-input
                    id="precioneto"
                    :state="errors.length > 0 ? false : null"
                    v-model="medicamento.precioNeto"
                    type="text"
                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label-for="preciotecho">
                <label>Precio Techo: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="preciotecho"
                  rules="required"
                >
                  <b-form-input
                    id="preciotecho"
                    :state="errors.length > 0 ? false : null"
                    v-model="medicamento.precioTecho"
                    type="text"
                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label-for="nummax">
                <label>Num Max: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="nummax"
                  rules="required"
                >
                  <b-form-input
                    id="numMax"
                    v-model="medicamento.numMax"
                    type="number"
                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                    required
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label-for="establecimiento">
                <label
                  >Establecimiento: <span class="text-danger">*</span></label
                >
                <validation-provider
                  #default="{ errors }"
                  name="establecimiento"
                  rules="required"
                >
                  <v-select
                    id="establecimiento"
                    v-model="medicamento.establecimiento"
                    placeholder="Buscar por establecimiento."
                    :options="establecimientos"
                    :reduce="(option) => option.value"
                    label="text"
                    class="d-inline-block w-100"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label-for="presentacion">
                <label>Presentación: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="presentacion"
                  rules="required"
                >
                  <b-form-input
                    id="presentacion"
                    :state="errors.length > 0 ? false : null"
                    v-model="medicamento.presentacion"
                    type="text"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Estado:" label-for="estado-switch">
                <b-form-checkbox
                  id="estado-switch"
                  v-model="medicamento.estado"
                  value="1"
                  unchecked-value="0"
                  switch
                  disabled
                >
                </b-form-checkbox>
              </b-form-group>
              <b-button type="submit" variant="primary" :disabled="invalid"
                >Crear Medicamento</b-button
              >
            </b-form>
          </validation-observer>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  data() {
    return {
      medicamento: {
        id: "",
        nombre: "",
        codigo: "",
        precioNeto: 0,
        precioTecho: 0,
        numMax: 1,
        presentacion: "",
        establecimiento: "",
        estado: "1",
      },
    };
  },
  created() {
    // aqui se colocan las funciones que aparezcan cargadas cuando se haga un post o un f5 de la misma.
    const idMedicamento = this.$route.params.id;
    console.log(idMedicamento);
    this.fetchEstablecimientos();
  },
  methods: {
    async fetchEstablecimientos() {
      const query = `
                        query {
                            allEstablecimientos {
                                id
                                Descripcion
                                uniCodigo
                            }
                        }
                    `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        this.establecimientos = response.data.data.allEstablecimientos.map(
          (item) => ({
            value: item.id,
            text: item.Descripcion,
            uniCodigo: item.uniCodigo,
          })
        );
      } catch (error) {
        console.error("An error occurred while fetching the options:", error);
      }
    },
    async submitForm() {
      console.log(this.medicamento);
      const precioNetoFormateado = parseFloat(
        this.medicamento.precioNeto
      ).toFixed(4);
      const precioTechoFormateado = parseFloat(
        this.medicamento.precioTecho
      ).toFixed(4);
      console.log(precioNetoFormateado);
      const query = `
            mutation crearMedicamento($medicamento: MedicamentoInput!) {
            CrearMedicamento(medicamento: $medicamento) {
            medicamentoCreado {
            token
            id
            precioNeto
            precioTecho
            }
            status
            message
            }
            }   
           `;

      const variables = {
        medicamento: {
          codigo: this.medicamento.codigo,
          nombre: this.medicamento.nombre,
          presentacion: this.medicamento.presentacion,
          numMax: parseInt(this.medicamento.numMax),
          precioNeto: precioNetoFormateado,
          precioTecho: precioTechoFormateado,
          estado: this.medicamento.estado,
          establecimiento: this.medicamento.establecimiento,
        },
      };
      console.log(variables);

      try {
        // Realizar la solicitud GraphQL utilizando axios
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });
        console.log("imprimir response", response.data.data.CrearMedicamento);

        // Verificar si la operación fue exitosa
        if (response.data.data.CrearMedicamento.status === "success") {
          // Mostrar una alerta de éxito
          await this.$swal({
            icon: "success",
            title: "Éxito",
            text: "El medicamento se creó correctamente.",
          });

          // Redirigir a otra página si es necesario

          this.$router.push({ name: "consultar_cartera_farmaco" });

          // Limpiar el formulario o realizar otras acciones necesarias
          // this.medicamento = { ... };
        } else {
          // Manejar el caso de error
          this.$swal({
            title: "Error",
            text: response.data.data.crearAdmision.message,
            icon: "error",
            confirmButtonColor: "#089599",
          });
        }
      } catch (error) {
        // Mostrar una alerta de error si la solicitud falla
        await this.$swal({
          icon: "error",
          title: "Error",
          text: error.message || "Hubo un problema al crear el medicamento.",
        });
      }
    },
  },
};
</script>
